// extracted by mini-css-extract-plugin
export var cardIcon = "_9n-4";
export var checkboxCard = "_9n-0";
export var checkboxCardSelected = "_9n-3";
export var disabled = "_9n-1";
export var outerBorder = "_9n-2";
export var spacerMedium = "_9n-7";
export var spacerSmall = "_9n-6";
export var spacerXsmall = "_9n-5";